import { ReactElement, useCallback } from 'react';
import { useInfiniteScroll } from '@components/common';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { SiteListCard } from '@components/lms/siteListWrapper/components';
import { useSiteListQuery } from '@services/hooks/lms/siteList/useSiteListQuery';
import { useSiteListRxDb } from '@services/hooks/lms/siteList/useSiteListRxDb';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import { useSetMainHeader } from '@hooks/useSetMainHeader';
import { useRefetchList } from '@helper/fetchData';

export const AllSiteList = (): ReactElement => {
	useSetMainHeader('Site Summary');
	useRefetchList(['AllSites']);
	const { isFetching: queryFetch, error } = useSiteListQuery();
	const { fetchMore, isFetching, result } = useSiteListRxDb();

	const handleFetchMore = useCallback(() => {
		fetchMore();
	}, [fetchMore]);

	useInfiniteScroll(handleFetchMore);

	return (
		<Wrapper isLoaderVisible={queryFetch || (isFetching && result.length === 0)} isError={error}>
			<div className="common-list-card">
				<ul className="row">
					{result.length > 0 ? (
						result.map((site) => <SiteListCard key={site?._data?.id} site={site?._data} isContractorSite={false} />)
					) : (
						<NoDataFound message="No Data Found!" />
					)}
				</ul>
			</div>
		</Wrapper>
	);
};
